<div [ngClass]="{'publishing': publishing, 'videocontainer': 'true'}" #publisherDiv></div>
